import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/SiteLayout";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      ...seo({
        title: "About Us | Wholesale Japanese Tea & Private Label Supplier | QT Foods",
        description:
          "Learn about QT Foods, a direct from Japan tea supplier offering B2B wholesale matcha, sencha, hojicha, and private label solutions.",
      }),
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <SiteLayout breadcrumbs={[{ label: "About Us" }]}>
      <section className="mx-auto max-w-3xl px-5 pt-10 pb-20 lg:px-8 lg:pt-14 lg:pb-28">
        <h1 className="mt-3 font-serif text-5xl md:text-6xl leading-[1.05]">
          A trading house for Japanese tea.
        </h1>
        <div className="mt-10 space-y-6 text-base leading-relaxed text-foreground/85">
          <p>
            QT Foods is part of a family of companies built around long, careful relationships with
            Japanese tea growers. We work directly with gardens across Uji, Nishio, Shizuoka and
            Kagoshima to source matcha, sencha, hojicha and the teaware that belongs alongside them.
          </p>
          <p>
            Our role is quiet but specific: we make it simple for serious buyers — retailers,
            roasters, hospitality groups and corporate gifting programs — to access the same quality
            and consistency our parent brand has built over years of work in Japan.
          </p>
          <p>
            Every product in our catalog is available in bulk and as a blank-label / private-label
            offering. You bring the brand; we bring the tea, the packaging and the supply chain.
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}
